/** @format */

/**
 * Reads a query parameter from `location.search` without applying the
 * `application/x-www-form-urlencoded` rule that turns "+" into a space.
 * Use this for secrets in `?key=` so pasted URLs keep "+" and match the API config.
 */
export function getRawQueryParam(search: string, name: string): string {
  if (!search || !name) return "";
  const safeName = name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const query = search.startsWith("?") ? search : `?${search}`;
  const m = query.match(new RegExp(`[?&]${safeName}=([^&]*)`));
  if (!m) return "";
  try {
    return decodeURIComponent(m[1]);
  } catch {
    return m[1];
  }
}
